<div class="menubar-hoverable header-fixed menubar-pin">
  <div id="base">
    <div class="offcanvas"></div>

    <div id="content">
      <div class="bv2-page">
        <div class="bv2-header">
    <div>
      <h1 class="bv2-title">{{ 'bv2PageTitle' | translate }}</h1>
      <p class="bv2-subtitle">{{ 'bv2PageSubtitle' | translate }}</p>
    </div>
    <div class="bv2-header-actions">
      <select class="bv2-native-select bv2-academic-year-select" [(ngModel)]="selectedAcademicYearId" (ngModelChange)="onAcademicYearChange()">
        <option *ngFor="let year of academicYears" [value]="year.id">
          {{ year.label }}<ng-container *ngIf="year.isCurrent">{{ 'bv2CurrentYearSuffix' | translate }}</ng-container>
        </option>
      </select>
      <button type="button" class="bv2-new-btn" *ngIf="isCreateBroadcastEnabled" (click)="openNewBroadcastPanel()">
        <i class="ph ph-plus"></i>
        {{ 'bv2NewBroadcastBtn' | translate }}
      </button>
    </div>
  </div>

  <div class="bv2-stats-row" *ngIf="!isLoadingBroadcasts">
    <div class="bv2-stat-card" *ngFor="let stat of broadcastStats">
      <div class="bv2-stat-icon" [ngClass]="getStatIconClass(stat.slug)">
        <i class="ph ph-fill" [ngClass]="getStatIcon(stat.slug)"></i>
      </div>
      <div class="bv2-stat-text">
        <div class="bv2-stat-value">{{ stat.value | number }}</div>
        <div class="bv2-stat-label">{{ stat.title }}</div>
      </div>
    </div>
  </div>
  <div class="bv2-stats-row" *ngIf="isLoadingBroadcasts">
    <div class="bv2-stat-card" *ngFor="let _ of skeletonStatCards">
      <p-skeleton shape="circle" size="38px"></p-skeleton>
      <div class="bv2-stat-text">
        <p-skeleton width="60px" height="1.2rem" styleClass="bv2-skeleton-line"></p-skeleton>
        <p-skeleton width="90px" height="0.8rem" styleClass="bv2-skeleton-line-sm"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="bv2-table-card">
    <div class="bv2-toolbar">
      <div class="bv2-search-box">
        <i class="ph ph-magnifying-glass"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="{{ 'bv2SearchPlaceholder' | translate }}" />
      </div>

      <div class="bv2-filters">
        <select class="bv2-native-select" [(ngModel)]="selectedStatusLabel" (change)="selectStatus(selectedStatusLabel)">
          <option [ngValue]="null">{{ 'bv2AllStatusOption' | translate }}</option>
          <option *ngFor="let option of statusFilterOptions" [value]="option.label">{{ option.label }}</option>
        </select>

        <div class="bv2-date-filter-wrap">
          <select class="bv2-native-select" [ngModel]="selectedDateFilterKey" (change)="onDateFilterChange($event)">
            <option value="All time">{{ 'bv2AllTimeOption' | translate }}</option>
            <option value="Last 30 days">{{ 'bv2Last30DaysOption' | translate }}</option>
            <option value="Last 7 days">{{ 'bv2Last7DaysOption' | translate }}</option>
            <option value="Choose date">{{ 'bv2ChooseDateOption' | translate }}</option>
            <option *ngIf="customDateLabel" [value]="customDateLabel">{{ customDateLabel }}</option>
          </select>

          <div class="bv2-inline-calendar-wrap" *ngIf="isChooseDateOpen">
            <p-calendar
              [(ngModel)]="selectedDate"
              [inline]="true"
              dateFormat="M dd, yy"
              (onSelect)="onCalendarDateSelected($event)"
            ></p-calendar>
          </div>
        </div>
      </div>
    </div>

    <div class="bv2-table-scroll">
      <table class="bv2-table">
        <thead>
          <tr>
            <th>
              <span class="bv2-th-sortable">{{ 'bv2ColBroadcast' | translate }} <i class="ph ph-caret-up-down"></i></span>
            </th>
            <th>
              <span class="bv2-th-sortable">{{ 'bv2ColSentOn' | translate }} <i class="ph ph-caret-up-down"></i></span>
            </th>
            <th>
              <span class="bv2-th-sortable">{{ 'bv2ColViewsReadPercent' | translate }} <i class="ph ph-caret-up-down"></i></span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoadingBroadcasts && !broadcasts.length">
          <tr>
            <td colspan="4">
              <div class="bv2-no-data">
                <i class="ph ph-fill ph-tray"></i>
                <div class="bv2-no-data-text">{{ 'bv2NoBroadcastsFound' | translate }}</div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoadingBroadcasts">
          <tr *ngFor="let row of broadcasts" class="bv2-clickable-row" (click)="openBroadcastDetail(row)">
            <td>
              <div class="bv2-broadcast-title-row">
                <div class="bv2-broadcast-title">{{ row.title }}</div>
                <span class="bv2-media-badge" *ngIf="row.media?.length">
                  <i class="ph ph-paperclip"></i>
                  {{ row.media?.length }}
                </span>
              </div>
              <div class="bv2-broadcast-subtitle">{{ row.subtitle }}</div>
            </td>
            <td>
              <div class="bv2-sent-date">{{ row.sentOnDate }}</div>
              <div class="bv2-sent-time">{{ row.sentOnTime }}</div>
            </td>
            <td>
              <div class="bv2-views-row">
                <span class="bv2-views-count">{{ row.views }} {{ 'bv2ViewsSuffix' | translate }}</span>
                <span class="bv2-read-percent">{{ row.readPercent }}%</span>
              </div>
              <div class="bv2-progress-track">
                <div class="bv2-progress-fill" [style.width.%]="row.readPercent"></div>
              </div>
            </td>
            <td class="bv2-row-arrow">
              <i class="ph ph-caret-right"></i>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="isLoadingBroadcasts">
          <tr *ngFor="let _ of skeletonRows">
            <td><p-skeleton width="70%" styleClass="bv2-skeleton-line"></p-skeleton><p-skeleton width="40%" styleClass="bv2-skeleton-line-sm"></p-skeleton></td>
            <td><p-skeleton width="60%" styleClass="bv2-skeleton-line"></p-skeleton><p-skeleton width="40%" styleClass="bv2-skeleton-line-sm"></p-skeleton></td>
            <td><p-skeleton width="60%" styleClass="bv2-skeleton-line"></p-skeleton></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bv2-pagination-bar">
      <p-paginator
        [first]="paginatorFirst"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPaginatorPageChange($event)"
      ></p-paginator>
    </div>
  </div>
</div>

<div class="bv2-detail-overlay" *ngIf="isDetailPanelOpen" (click)="closeBroadcastDetail()"></div>
<div class="bv2-detail-panel" *ngIf="isDetailPanelOpen && selectedBroadcast" (scroll)="onViewersScroll($event)">
  <div class="bv2-detail-header">
    <div class="bv2-detail-title-wrap">
      <h2 class="bv2-detail-title" [class.bv2-detail-title-clamped]="!isDetailTitleExpanded">{{ selectedBroadcast.title }}</h2>
      <button
        type="button"
        class="bv2-detail-title-toggle"
        *ngIf="selectedBroadcast.title?.length > 60"
        (click)="toggleDetailTitleExpanded()"
      >
        {{ (isDetailTitleExpanded ? 'bv2ReadLess' : 'bv2ReadMore') | translate }}
      </button>
    </div>
    <button type="button" class="bv2-detail-close-btn" (click)="closeBroadcastDetail()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="bv2-detail-meta">
    <span>{{ 'bv2SentLabel' | translate }}<strong>{{ selectedBroadcast.sentOnDate }} · {{ selectedBroadcast.sentOnTime }}</strong></span>
  </div>

  <div class="bv2-detail-message">
    {{ selectedBroadcast.message }}
  </div>

  <div class="bv2-detail-stats">
    <div class="bv2-detail-stat-card">
      <div class="bv2-detail-stat-value">{{ selectedBroadcast.recipients }}</div>
      <div class="bv2-detail-stat-label">{{ 'bv2Recipients' | translate }}</div>
    </div>
    <div class="bv2-detail-stat-card">
      <div class="bv2-detail-stat-value bv2-detail-stat-blue">{{ selectedBroadcast.views ?? '—' }}</div>
      <div class="bv2-detail-stat-label">{{ 'bv2Viewed' | translate }}</div>
    </div>
    <div class="bv2-detail-stat-card">
      <div class="bv2-detail-stat-value bv2-detail-stat-green">{{ selectedBroadcast.readPercent !== null ? (selectedBroadcast.readPercent + '%') : '—' }}</div>
      <div class="bv2-detail-stat-label">{{ 'bv2ReadRate' | translate }}</div>
    </div>
  </div>

  <div class="bv2-detail-media-section" *ngIf="selectedBroadcast.media?.length">
    <h3 class="bv2-detail-viewers-heading">{{ 'bv2AttachmentsHeading' | translate }}</h3>
    <div class="bv2-media-grid">
      <div class="bv2-media-card" *ngFor="let item of selectedBroadcast.media" (click)="openMediaPreview(item)">
        <ng-container *ngIf="item.type === 'image'; else documentCard">
          <img [src]="item.url" [alt]="item.label" class="bv2-media-thumbnail" />
        </ng-container>
        <ng-template #documentCard>
          <div class="bv2-media-doc">
            <i class="ph ph-fill ph-file-pdf"></i>
          </div>
        </ng-template>
        <div class="bv2-media-label">{{ item.label }}</div>
      </div>
    </div>
  </div>

  <div class="bv2-detail-viewers-section">
    <h3 class="bv2-detail-viewers-heading">{{ 'bv2WhoViewedHeading' | translate }}</h3>
    <div class="bv2-search-box bv2-viewers-search-box">
      <i class="ph ph-magnifying-glass"></i>
      <input type="text" [(ngModel)]="viewersSearchTerm" (input)="onViewersSearchChange()" placeholder="{{ 'bv2SearchViewersPlaceholder' | translate }}" />
    </div>
    <div class="bv2-viewer-row" *ngFor="let viewer of selectedBroadcast.viewers">
      <div class="bv2-viewer-avatar" [style.background-color]="viewer.image ? null : viewer.avatarColor">
        <img *ngIf="viewer.image" [src]="viewer.image" [alt]="viewer.name" class="bv2-viewer-avatar-img" />
        <ng-container *ngIf="!viewer.image">{{ viewer.initials }}</ng-container>
      </div>
      <div class="bv2-viewer-info">
        <div class="bv2-viewer-name">{{ viewer.name }}</div>
        <div class="bv2-viewer-role">{{ viewer.type }}<ng-container *ngIf="viewer.className"> · {{ viewer.className }}</ng-container></div>
      </div>
      <div class="bv2-viewer-time" *ngIf="viewer.viewedAt; else notViewed">
        <div class="bv2-viewer-time-value">{{ viewer.viewedAt }}</div>
        <div class="bv2-viewer-time-date">{{ viewer.viewedDate }}</div>
      </div>
      <ng-template #notViewed>
        <span class="bv2-viewer-not-viewed">{{ 'bv2NotViewed' | translate }}</span>
      </ng-template>
    </div>
    <div class="bv2-viewers-loading" *ngIf="isLoadingViewers">
      <p-skeleton width="36px" height="36px" shape="circle"></p-skeleton>
      <div class="bv2-stat-text">
        <p-skeleton width="120px" height="0.9rem" styleClass="bv2-skeleton-line"></p-skeleton>
        <p-skeleton width="80px" height="0.75rem" styleClass="bv2-skeleton-line-sm"></p-skeleton>
      </div>
    </div>
    <div class="bv2-detail-no-viewers" *ngIf="!isLoadingViewers && !selectedBroadcast.viewers?.length">
      {{ 'bv2NoViewsYet' | translate }}
    </div>
  </div>
</div>

<div class="bv2-detail-overlay" *ngIf="isNewBroadcastPanelOpen" (click)="closeNewBroadcastPanel()"></div>
<div class="bv2-detail-panel" *ngIf="isNewBroadcastPanelOpen">
  <div class="bv2-detail-header">
    <div>
      <h2 class="bv2-detail-title">{{ 'bv2NewBroadcastBtn' | translate }}</h2>
      <p class="bv2-new-broadcast-subtitle">{{ 'bv2NewBroadcastSubtitle' | translate }}</p>
    </div>
    <button type="button" class="bv2-detail-close-btn" (click)="closeNewBroadcastPanel()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="bv2-form-section">
    <label class="bv2-form-label">{{ 'bv2SendToLabel' | translate }} <span class="bv2-required-mark">*</span></label>
    <div class="bv2-audience-options">
      <button
        type="button"
        class="bv2-audience-card"
        *ngFor="let option of audienceOptions"
        [class.bv2-audience-card-active]="selectedAudience === option.key"
        (click)="selectAudience(option.key)"
      >
        <div class="bv2-audience-icon" [class.bv2-audience-icon-active]="selectedAudience === option.key">
          <i class="ph" [ngClass]="option.icon"></i>
        </div>
        <div class="bv2-audience-label">{{ option.label }}</div>
        <div class="bv2-audience-count">{{ option.peopleCount }} {{ 'bv2PeopleSuffix' | translate }}</div>
      </button>
    </div>
  </div>

  <div class="bv2-form-section">
    <label class="bv2-form-label" for="newBroadcastTitle">{{ 'bv2TitleLabel' | translate }} <span class="bv2-required-mark">*</span></label>
    <input
      id="newBroadcastTitle"
      type="text"
      class="bv2-form-input"
      placeholder="{{ 'bv2TitlePlaceholder' | translate }}"
      [(ngModel)]="newBroadcastTitle"
    />
  </div>

  <div class="bv2-form-section">
    <label class="bv2-form-label" for="newBroadcastDescription">{{ 'bv2DescriptionLabel' | translate }} <span class="bv2-required-mark">*</span></label>
    <textarea
      id="newBroadcastDescription"
      class="bv2-form-textarea"
      rows="5"
      placeholder="{{ 'bv2DescriptionPlaceholder' | translate }}"
      [(ngModel)]="newBroadcastDescription"
    ></textarea>
  </div>

  <div class="bv2-form-section">
    <label class="bv2-form-label">
      {{ 'bv2AttachmentsLabel' | translate }} <span class="bv2-optional-mark">{{ 'bv2AttachmentsOptionalMark' | translate: { count: maxBroadcastAttachments } }}</span>
    </label>
    <div
      class="bv2-attachment-dropzone"
      [class.bv2-attachment-dropzone-over]="isNewBroadcastDragOver"
      (dragover)="onNewBroadcastDragOver($event)"
      (dragleave)="onNewBroadcastDragLeave($event)"
      (drop)="onNewBroadcastDrop($event)"
      *ngIf="newBroadcastAttachments.length < maxBroadcastAttachments"
    >
      <input type="file" id="newBroadcastFile" class="bv2-hidden-file-input" accept="image/*,application/pdf" multiple
        (change)="onNewBroadcastFileChange($event)" />
      <div class="bv2-attachment-icon">
        <i class="ph ph-upload-simple"></i>
      </div>
      <div class="bv2-attachment-text">
        {{ 'bv2DropFilesText' | translate }}<label for="newBroadcastFile" class="bv2-browse-link">{{ 'bv2BrowseLink' | translate }}</label>
      </div>
      <div class="bv2-attachment-note">{{ 'bv2AttachmentNote' | translate: { count: maxBroadcastAttachments } }}</div>
    </div>
    <div class="bv2-attachment-selected-list" *ngIf="newBroadcastAttachments.length > 0">
      <div class="bv2-attachment-selected" *ngFor="let file of newBroadcastAttachments; let i = index">
        <i class="ph ph-file"></i>
        <span class="bv2-attachment-filename">{{ file.name }}</span>
        <button type="button" class="bv2-attachment-remove-btn" (click)="removeNewBroadcastAttachment(i)">
          <i class="ph ph-x"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="bv2-form-actions">
    <button type="button" class="bv2-cancel-btn" (click)="closeNewBroadcastPanel()">{{ 'bv2CancelBtn' | translate }}</button>
    <button
      type="button"
      class="bv2-send-btn"
      [disabled]="!newBroadcastTitle.trim() || !newBroadcastDescription.trim() || !selectedAudience || isSendingBroadcast"
      (click)="sendNewBroadcast()"
    >
      <i class="ph ph-fill ph-paper-plane-tilt"></i>
      {{ (isSendingBroadcast ? 'bv2SendingBtn' : 'bv2SendBroadcastBtn') | translate }}
    </button>
  </div>
</div>

<div class="bv2-media-preview-overlay" *ngIf="isMediaPreviewOpen && previewMedia" (click)="closeMediaPreview()">
  <button type="button" class="bv2-media-preview-close-btn" (click)="closeMediaPreview()">
    <i class="ph ph-x"></i>
  </button>
  <div class="bv2-media-preview-content" [class.bv2-media-preview-content-doc]="previewMedia.type === 'document'" (click)="$event.stopPropagation()">
    <ng-container *ngIf="previewMedia.type === 'image'; else documentPreview">
      <img [src]="previewMedia.url" [alt]="previewMedia.label" class="bv2-media-preview-image" />
    </ng-container>
    <ng-template #documentPreview>
      <iframe [src]="previewMediaSafeUrl" class="bv2-media-preview-iframe" [title]="'bv2PdfPreviewTitle' | translate"></iframe>
    </ng-template>
    <div class="bv2-media-preview-label">{{ previewMedia.label }}</div>
  </div>
</div>
    </div>
  </div>
</div>
